import React, { useMemo } from 'react'

import { NodeStatsItem } from 'common/builder/components/chart/FlowChart/components/Node/components/NodeStats/NodeStatsItem/NodeStatsItem'
import { FlowChartStatRow } from 'common/builder/components/chart/FlowChart/types/FlowChartStatRow'

import * as styles from './NodeStatsRow.styles'

interface NodeStatsRowProps {
  row: FlowChartStatRow
  style?: React.CSSProperties
}

export const NodeStatsRow = React.memo(({ row, style = {} }: NodeStatsRowProps) => {
  const combinedStyle = useMemo(() => ({ ...style, ...styles.wrapper }), [style])

  return (
    <view style={combinedStyle}>
      {row.cols.map((col, index) => (
        <NodeStatsItem key={index} item={col} />
      ))}
    </view>
  )
})
